module.exports = __webpack_public_path__ + "static/media/16.995fb1c3.mp3";